

import {  useEffect, useState } from "react";
import '../pages/SettingPageuser.css'
import './EditModalDam.css'
import { useGlobalContext } from "./Context";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import apiService from "../api/ApiService";
import { addComments } from "../redux/slices/commentsSlice";
import { toast } from "react-toastify";
import { TicketList } from "../redux/slices/adminSlice";
import AddToPhotosIcon from '@mui/icons-material/AddToPhotos';
import { Close } from "@mui/icons-material";


const AddTicket=()=>{
    const {tickets}=useSelector(state=>state.p.admin)
    
    const [comment,setComment]=useState('');
    const [title,setTitle]=useState('');
    const [types,setTypes]=useState([])
    const [type,setType]=useState(0)


    const {isModalCommentOpen,closeModallComment,openModallComment}=useGlobalContext();
   
    const dispatch=useDispatch();
    const navigate=useNavigate()
    
    const AddNewSensor=async()=>{
       
        if(comment&&title&&comment.length<1000&&title.length<100){
            const data=JSON.stringify({
                "title": title,
                "question": comment,
              })
            const res=await apiService.AddTicket(data);
            const obj={
                ...res.data,
                'response':'',
                'responseDate':''
            }
            dispatch(TicketList([...tickets,obj]))
            openModallComment()
       }
       else if(comment.length>2000&&title.length>200){
        toast( 'برای موضوع 200 کاراکتر و برای متن 2000 کاراکتر مجاز است')
       }
       else{
        toast('تمامی مقادیر را وارد کنید')
       }
       
    }
 
    

    return <div onClick={closeModallComment} className={`modal-overlay ${isModalCommentOpen&&'show-modal'} `}>
        <div className="editModalDamCon Ani AllFFFF" >
        <div className="closee"><Close className='closee'/></div>
            <div className="editModalDamConHead">
            <AddToPhotosIcon fontSize="large"/>

            <h4 > ایجاد تیکت جدید</h4>
            </div>
       
            <div className='inputContainerSS'>
            <input autoComplete="off" type="text"  className='inputSS' placeholder="a" defaultValue={title} onChange={(e)=>setTitle(e.target.value)}/>
            <label for="" className={'labelSS'}> موضوع </label>
        </div>
       
        <div className='inputContainerSS2'>
            <textarea autoComplete="off" type="text"   className='inputSS inputSSText2' placeholder="a" onChange={(e)=>setComment(e.target.value)}/>
            <label for="" className={'labelSS labelText'}>متن</label>
        </div>
        
        <button className="EditMOdalBtnForm" onClick={()=>{
            AddNewSensor()
        }}>
            تایید
        </button>
        
        </div>
        <div style={{marginTop:'120px'}}> 
        
        </div>
        
    </div>
}
export default  AddTicket